import { useCheckoutContext } from "context/checkout-context";
import { toMoneyWithTwoDecimalDigits } from "utils/currency";
import "./index.scss";
import { Loader } from "components/UI/atoms";
import PlatformFee from "../platform-fee";

export const StatusArea = ({ isCartLoading = false }) => {
  const {
    checkoutData: { service_fee, subtotal, total, total_savings },
    isLoading
  } = useCheckoutContext();
  const showPlatformFee = service_fee?.applied && service_fee?.amount > 0;
  return (
    <div className="status-area">
      {!isCartLoading && !isLoading ? (
        <div className="subtotal">
          <div className="row">
            Subtotal{""}
            <strong>{toMoneyWithTwoDecimalDigits(subtotal)}</strong>
          </div>
          {showPlatformFee && (
            <PlatformFee noPadding serviceFee={service_fee} />
          )}
          <div className={`row ${!showPlatformFee && "top-padding"}`}>
            Total{""}
            <strong>{toMoneyWithTwoDecimalDigits(total)}</strong>
          </div>
          <div className="bottom-row">
            Total Savings{""}
            <span>{toMoneyWithTwoDecimalDigits(total_savings)}</span>
          </div>
        </div>
      ) : (
        <div className="center">
          <Loader variant="secondary" id="listings-loader" />
        </div>
      )}
    </div>
  );
};
